import iconGuide from '../../assets/img/icon/guide.svg';
import iconSelect from '../../assets/img/icon/select.svg';
import iconRedo from '../../assets/img/icon/redo.svg';
import iconReset from '../../assets/img/icon/reset.svg';
import iconRuler from '../../assets/img/icon/ruler.svg';
import iconStamp from '../../assets/img/icon/stamp.svg';
import iconFreeText from '../../assets/img/icon/text.svg';
import iconUndo from '../../assets/img/icon/undo.svg';
import iconTrimming from '../../assets/img/icon/trimming.svg';
import iconRotateFrame from '../../assets/img/icon/rotate_middle_frame.svg';

export type ToolbarItemType =
  'guide'
  | 'select' // 手のひらツール
  | 'insert-stamp' // スタンプ
  | 'insert-text' // テキスト追加
  | 'ruler' // ルーラー
  | 'trimming'
  | 'rotate-middle-frame'
  | 'undo'
  | 'redo'
  | 'reset'

export const TRIM_TOOLBAR_ITEM_LIST: {
  type: ToolbarItemType,
  icon: string,
  label: string,
  DAIFlag?: boolean,
  divider?: boolean,
}[] = [
  {
    type: 'select',
    icon: iconSelect,
    label: '選択ツール',
  },
  // {
  //   type: 'insert-stamp',
  //   icon: iconStamp,
  //   label: 'スタンプ追加',
  // },
  {
    type: 'insert-text',
    icon: iconFreeText,
    label: 'テキスト追加',
  },
  {
    type: 'ruler',
    icon: iconRuler,
    label: 'ルーラー',
  },
  {
    type: 'trimming',
    icon: iconTrimming,
    label: '人寸トリミング',
    divider: true,
  },
  {
    type: 'rotate-middle-frame',
    icon: iconRotateFrame,
    label: '枠の回転',
  },
  {
    type: 'undo',
    icon: iconUndo,
    label: '元に戻す',
    divider: true,
  },
  {
    type: 'redo',
    icon: iconRedo,
    label: 'やり直し',
  },
  {
    type: 'reset',
    icon: iconReset,
    label: 'リセット',
  },
];
